module.exports = __webpack_public_path__ + "static/media/pic37.137625f8.jpg";